const isObject = obj => {
  if (obj === null) return false;
  return typeof obj === "function" || typeof obj === "object";
};

export default isObject;
